import { render, staticRenderFns } from "./TableVis.vue?vue&type=template&id=08a0f61a&scoped=true&v-if=vis_data_cols.length%20%3E%200&"
import script from "./TableVis.vue?vue&type=script&lang=js&"
export * from "./TableVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0f61a",
  null
  
)

export default component.exports